const _LOCAL_STORAGE_KEY = 'recentGames'
const _MAX_GAMES = 15

const getRecentGames = () => {
  const recentGames = localStorage.getItem(_LOCAL_STORAGE_KEY)
  if (!recentGames) {
    return []
  }
  const recentParsed = JSON.parse(recentGames)
  // TODO: remove eventually
  const fixedGames = fixFormatting(recentParsed)
  if (JSON.stringify(fixedGames) !== recentGames) {
    const trimmedGames = fixedGames.slice(0, _MAX_GAMES)
    localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(trimmedGames))
    return trimmedGames
  } else {
  }
  return recentParsed.slice(0, _MAX_GAMES)
}

// upper + 32 == lower
// converts from camelCase to snake_case
const fixFormatting = (recentGames) => {
  const updated = recentGames.map(rg => {
    const newObj = {}
    Object.keys(rg).forEach(key => {
      const val = rg[key]
      let newKey = ''
      key.split('').forEach((char, idx) => {
        if (char.match(/[A-Z]/)) {
          const charCode = char.charCodeAt() + 32
          newKey += `_${String.fromCharCode(charCode)}`
        } else {
          newKey += char
        }
      })
      newObj[newKey] = val
    })
    return newObj
  })
  return updated
}

const addRecentGame = (game) => {
  const recentGames = getRecentGames()
  const existingGame = recentGames.find(g => g.short_id === game.short_id)
  const formattedGame = {
    ...game,
    last_played_at: new Date().toISOString(),
    completed_at: existingGame?.completed_at || null,
  }
  const existingGameIndex = recentGames.findIndex(g => g.short_id === formattedGame.short_id)
  if (existingGameIndex > -1) {
    recentGames.splice(existingGameIndex, 1)
  }
  if (recentGames.length >= _MAX_GAMES) {
    recentGames.pop()
  }
  const newRecentGames = [formattedGame, ...recentGames]
  localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(newRecentGames))
}

const markRecentGameCompleted = (shortId) => {
  if (!shortId) {
    return
  }
  const recentGames = getRecentGames()
  const existingGameIndex = recentGames.findIndex(g => g.short_id === shortId)
  if (existingGameIndex === -1) {
    return
  }
  const existing = recentGames[existingGameIndex]
  recentGames[existingGameIndex] = {
    ...existing,
    completed_at: existing.completed_at || new Date().toISOString(),
  }
  localStorage.setItem(_LOCAL_STORAGE_KEY, JSON.stringify(recentGames))
}

const getCachedGame = (shortId) => {
  const recentGames = getRecentGames()
  return recentGames.find(g => g.short_id === shortId)
}

export { getRecentGames, addRecentGame, getCachedGame, markRecentGameCompleted }
